<template>
  <v-sheet height="92dvh" class="bg-login-background pa-2 overflow-y-auto">
    <v-card class="mx-auto mt-16 px-6 py-8 " :max-width="smAndUp ? 400 : '100vw'" elevation="0">
      <v-form v-model="form" @submit.prevent="onSubmit">
        <v-img class="mb-6 py-0 rounded" :src="orgLogo"></v-img>
        <v-text-field v-model="rollNumber" color="primary" :readonly="loading" :rules="[required]" class="mb-2"
          clearable variant="outlined" label="Roll Number / Registration Number"
          prepend-inner-icon="mdi-account"></v-text-field>

        <v-text-field class="noautofill-bgcolor" v-model="password" color="primary" :readonly="loading"
          :rules="[required]" clearable label="Activation Code / Password" variant="outlined"
          prepend-inner-icon="mdi-lock" type="password"></v-text-field>

        <v-btn class="mt-4" :disabled="!form" :loading="loading" block color="primary" size="large" type="submit"
          variant="elevated">
          Sign In
        </v-btn>
        <div v-if="authErrorMsg" role="alert" class="pl-4 text-wrap text-error auth-error">
          {{ authErrorMsg }}
        </div>
        <div class="phonenumber-login-container">
          Don't have a VMC Account, <span class="phonenumber-login-text" @click="toggleSignup">Sign up</span> here
        </div>
      </v-form>
    </v-card>
  </v-sheet>
  <v-footer height="8dvh" absolute class="bg-login-background">
    <v-row justify="center" no-gutters>
      <v-btn color="white" variant="plain" class="mx-2 no-uppercase" :href="privacyPolicyUrl" target="_blank">
        {{ privacyPolicyLabel }}
      </v-btn>
      <v-label>|</v-label>
      <v-btn color="white" variant="plain" class="mx-2 no-uppercase" :href="aboutUsUrl" target="_blank">
        {{ aboutUsLabel }}
      </v-btn>
    </v-row>
    <span class="powered-by" v-if="mdAndUp">
      <span class=" powered-by-text">Powered by</span>
      <a :href="mentoWebSite" target="_blank">
        <span class="mento-text pl-1">Mento</span><span class="mind-text">Mind</span>
      </a>
    </span>
  </v-footer>
</template>

<script>
//import _ from "lodash";

import { mapState } from "vuex";
import { getDeviceId } from "@/services/authService";
import orgSignInLogo from "@/assets/vmc_logo_2_600.png";
import { v4 as uuidv4 } from 'uuid';
import { useDisplay } from 'vuetify';
import { AnalyticsEvents, recordAnalyticsEvent } from "@/services/awsPinpointAnalyticsService";

export default {
  name: 'SignIn',
  setup() {
    // Destructure only the keys we want to use
    const { xs, smAndUp, mdAndUp } = useDisplay()

    return { xs, smAndUp, mdAndUp }
  },

  created() {
    this.$store.commit("clearLoginError");
    this.$store.commit('appbarVisible', false);
    this.$store.commit('navbarVisible', false);
    this.$store.commit("clearSSOState");
  },
  mounted() {
    recordAnalyticsEvent(AnalyticsEvents.v2SignInPageOpen);
  },
  data: () => ({
    form: false,
    rollNumber: null,
    password: null,
    loading: false,
    showSignup: false,
    orgLogo: orgSignInLogo,
    privacyPolicyLabel: 'Privacy Policy',
    privacyPolicyUrl: 'https://www.vidyamandir.com/privacy_policy.html',
    aboutUsLabel: 'About Us',
    aboutUsUrl: 'https://www.vidyamandir.com/vmc_edge.html',
    mentoWebSite: 'https://mentomind.com/',
    identityType: "ROLLNUMBER",
  }),
  components:
  {
  },
  computed: {
    ...mapState(["userInfo", "loginError"]),
    authErrorMsg: {
      get() {
        let errMSG = '';
        if (this.loginError != '') {
          errMSG = this.loginError.error;
        }
        return errMSG;
      },
    },
  },
  watch: {

  },

  methods: {
    toggleSignup() {
      this.$router.push('/signup');
    },

    onSubmit() {
      if (!this.form) return

      this.loading = true
      let deviceId = getDeviceId();
      if (!deviceId || deviceId == '' || deviceId.toLowerCase() == 'undefined') {
        try {
          deviceId = crypto.randomUUID();
        } catch (err) {
          console.log(`Error in generating crypto.randomUUID : ${JSON.stringify(err)}`);
          deviceId = uuidv4();
        }
      }
      recordAnalyticsEvent(AnalyticsEvents.v2SignInAttempt,
        { loginValue: this.rollNumber, generatedDeviceId: deviceId, identityType: this.identityType });

      var loginRequest = {
        loginValue: this.rollNumber, passwordValue: this.password
        , deviceId: deviceId, identityType: this.identityType
      }
      let customeOrgIdQueryParam = this.$route.query.org;
      console.log(`is there customeOrgIdQueryParam: ${customeOrgIdQueryParam}`);
      if (customeOrgIdQueryParam) {
        loginRequest.orgId = customeOrgIdQueryParam;
        console.log("inside custom org")
        this.$store.dispatch("userLoginByCredentialsToSpecificOrg", loginRequest).then(() => {
          if (this.loginError != '') {
            //console.log(`error in login ... ${JSON.stringify(this.loginError)}`);
            recordAnalyticsEvent(AnalyticsEvents.v2SignInFailure,
              { loginValue: this.rollNumber, generatedDeviceId: deviceId, identityType: this.identityType });
            this.loading = false;
          }
          else {
            console.log(`Login Success. Load Domains and go to Learn`);
            recordAnalyticsEvent(AnalyticsEvents.v2SignInSuccess,
              { loginValue: this.rollNumber, generatedDeviceId: deviceId, identityType: this.identityType });
            this.$store.dispatch("getAPIUrlsForFlavorAndVersion").then(() => {

              this.$store.dispatch("loadDomainsList").then(() => {
                this.$router.push('/learn');

              });
            });
            //this.$store.commit('userLoggedInFlag', true);
            this.loading = false;
          }
        });

      } else {
        this.$store.dispatch("userLoginByCredentials", loginRequest).then(() => {

          if (this.loginError != '') {
            //console.log(`error in login ... ${JSON.stringify(this.loginError)}`);
            recordAnalyticsEvent(AnalyticsEvents.v2SignInFailure,
              { loginValue: this.rollNumber, generatedDeviceId: deviceId, identityType: this.identityType });
            this.loading = false;
          }
          else {
            console.log(`Login Success. Load Domains and go to Learn`);
            recordAnalyticsEvent(AnalyticsEvents.v2SignInSuccess,
              { loginValue: this.rollNumber, generatedDeviceId: deviceId, identityType: this.identityType });
            if (!this.$store.state.tempLoggedIn.showRefundPolicy) {
              this.$store.dispatch('LogInUser');
            }
            this.$store.dispatch("getAPIUrlsForFlavorAndVersion").then(() => {
              if (this.$store.state.tempLoggedIn.showRefundPolicy) {
                this.$router.push('/refundpolicy');
              } else {
                this.$store.dispatch("loadDomainsList").then(() => {
                  this.$router.push('/learn');
                });
              }
            });
            //this.$store.commit('userLoggedInFlag', true);
            this.loading = false;
          }
        });
      }
      //setTimeout(() => (this.loading = false), 2000)
    },
    nameRules(v) {
      v = v.trim();
      return v !== '' || 'Field is required';
    },

    required(v) {
      return !!v || 'Field is required'
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
footer {
  position: absolute;
  bottom: 0;
  width: 100%;
}

.phonenumber-login-container {
  margin-top: 15px;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
}

.phonenumber-login-text {
  color: blue;
  cursor: pointer;
  ;
  font-weight: 900;
}

.auth-error {
  font-size: 18px;
  text-align: center;
}

.no-uppercase {
  text-transform: unset !important;
}

.powered-by {
  position: absolute;
  bottom: 0;
  right: 0;
  margin-bottom: 10px;
  margin-right: 10px;
}

.powered-by-text {
  font-size: 12px;
  opacity: 0.4;
}

.mento-text {
  color: rgb(var(--v-theme-poweredby-mentoColor)) !important;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 2px;
}

.mind-text {
  color: rgb(var(--v-theme-poweredby-mindColor)) !important;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 2px;
}

a:link,
a:visited,
a:hover,
a:active {
  text-decoration: none;
}
</style>

<style>
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus {
  -webkit-box-shadow: 0 0 0px 1000px white#000 inset;
  transition: background-color 5000s ease-in-out 0s;
}
</style>